import { render, staticRenderFns } from "./AnimalToggleRow.vue?vue&type=template&id=bf196dba&scoped=true&"
import script from "./AnimalToggleRow.vue?vue&type=script&lang=js&"
export * from "./AnimalToggleRow.vue?vue&type=script&lang=js&"
import style0 from "./AnimalToggleRow.vue?vue&type=style&index=0&id=bf196dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf196dba",
  null
  
)

export default component.exports